export default {"src":"/_next/static/media/left-arrow.b61e71b5.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};